import React from 'react';
import { string, number } from 'prop-types';
import styles from './style.module.css';

export const getSeoRelLinks = (initialPage, totalPages, urlCanonical, isGridSeeAll) => {
  let urlCanonicalWithPage = urlCanonical;
  if (initialPage > 1 && !urlCanonical.includes('page=')) {
    urlCanonicalWithPage = urlCanonical.includes('?') ? `${urlCanonical}&page=${initialPage}` : `${urlCanonical}?page=${initialPage}`;
  }
  const canonical = <link rel="canonical" href={urlCanonicalWithPage} />;
  let prevRel = null;
  if (initialPage > 1) {
    const previousPage = initialPage - 1;
    let prevPageUrl =
      previousPage !== 1 ? urlCanonical.replace(`page=${initialPage}`, `page=${previousPage}`) : urlCanonical.replace(`page=${initialPage}`, '');
    if (prevPageUrl.split('?').length === 2) {
      prevPageUrl = prevPageUrl.replace('?', '');
    }
    if (previousPage > 1 && !prevPageUrl.includes('page=')) {
      prevPageUrl = prevPageUrl.includes('?') ? `${prevPageUrl}&page=${previousPage}` : `${prevPageUrl}?page=${previousPage}`;
    }
    prevRel = <link rel="prev" href={`${prevPageUrl}`} />;
  }
  let nextRel = null;
  const nextPage = initialPage + 1;
  if (nextPage <= totalPages) {
    let nextPageUrl = urlCanonical;
    if (urlCanonical.includes(`page=${initialPage}`)) {
      nextPageUrl = urlCanonical.replace(`page=${initialPage}`, `page=${nextPage}`);
    } else if (urlCanonical.includes('?')) {
      nextPageUrl = `${urlCanonical}&page=${nextPage}`;
    } else {
      nextPageUrl = `${urlCanonical}?page=${nextPage}`;
    }
    nextRel = <link rel="next" href={`${nextPageUrl}`} />;
  }
  return (
    <>
      {canonical}
      {isGridSeeAll ? prevRel : null}
      {isGridSeeAll ? nextRel : null}
    </>
  );
};

function replaceQueryParameter(oldString, param, value) {
  const re = new RegExp(`[\\?&]${param}=([^&#]*)`);
  const delimeter = re.exec(oldString)[0].charAt(0);
  const newString = oldString.replace(re, `${delimeter + param}=${value}`);

  return newString;
}

const getPagesHref = (currentUrl, page, currentPage, locale) => {
  let pageUrl = currentUrl.split(locale).pop();
  pageUrl = `/${locale}${pageUrl}`;
  if (pageUrl.includes('?')) {
    // Solo por ahora hasta que tengamos las canonicals, habra que borrar este if
    pageUrl = pageUrl.split('?').shift();
  }
  if (page !== 1) {
    if (pageUrl.includes('page=')) {
      pageUrl = replaceQueryParameter(pageUrl, 'page', page);
    } else if (pageUrl.includes('?')) {
      pageUrl = `${pageUrl}&page=${page}`;
    } else {
      pageUrl = `${pageUrl}?page=${page}`;
    }
  }
  return pageUrl;
};

function getPagesInRange(current, { min = 1, total = 20, length = 5 } = {}) {
  if (length > total) length = total;

  let start = current - Math.floor(length / 2);
  start = Math.max(start, min);
  start = Math.min(start, min + total - length);

  return Array.from({ length }, (el, i) => start + i);
}

function Paginator({ totalPages, currentPage, url, maxPageButtons = 5, locale }) {
  const displayPages = getPagesInRange(currentPage, { min: 1, total: totalPages, length: maxPageButtons });
  return (
    <div className={styles.pagination}>
      {Array.from({ length: totalPages }, (value, index) => {
        const pageValue = index + 1;
        const href = getPagesHref(url, pageValue, currentPage, locale);
        const className = currentPage !== pageValue ? '' : styles.active;
        const isNotInRange = !displayPages.includes(pageValue);
        const isLastPage = pageValue === totalPages;
        const isFirstPage = pageValue === 1;
        if (isNotInRange && !isLastPage && !isFirstPage) {
          /* className = `${className} ${styles.hidden}`; */
          return null;
        }
        if (isFirstPage) {
          const showDots = !displayPages.includes(2);
          return (
            <>
              <a key={pageValue} href={href} className={className}>
                {pageValue}
              </a>
              {showDots && (
                <span key="dots-start" className={styles.dots}>
                  ...
                </span>
              )}
            </>
          );
        }
        if (isLastPage) {
          const showDots = currentPage + maxPageButtons < totalPages;
          return (
            <>
              {showDots && (
                <span key="dots-end" className={styles.dots}>
                  ...
                </span>
              )}
              <a key={pageValue} href={href} className={className}>
                {pageValue}
              </a>
            </>
          );
        }
        return (
          <a key={pageValue} href={href} className={className}>
            {pageValue}
          </a>
        );
      })}
    </div>
  );
}

Paginator.propTypes = {
  totalPages: number,
  currentPage: number,
  url: string,
  locale: string,
  maxPageButtons: number,
};

export default Paginator;
